/* QUANTICA · <q-faq>
 *
 * Acordeon de preguntas frecuentes: una respuesta abierta a la vez.
 *
 * Reemplaza al patron de tabs que tenia antes esta seccion. El motivo no
 * fue semantico sino de layout: con tabs, las preguntas y las respuestas
 * viven en dos contenedores distintos, y en una sola columna la respuesta
 * termina al final de la lista entera en vez de debajo de la pregunta que
 * la abrio. Con los pares juntos en el DOM, el acordeon es el patron que
 * corresponde, y vale igual en escritorio y en telefono sin cambiar los
 * roles segun el ancho de la ventana.
 *
 * Sin este script se ven TODAS las respuestas abiertas. El contenido
 * nunca queda inaccesible porque un archivo no cargo; el script solo
 * agrega el plegado.
 *
 * El nombre va prefijado por su seccion y con guarda, como todo custom
 * element del theme: definir dos veces el mismo nombre no tira error, y
 * el segundo se descarta en silencio.
 */
(function () {
  'use strict';

  if (customElements.get('q-faq')) return;

  class QFaq extends HTMLElement {
    connectedCallback() {
      if (this.arrancado) return;
      this.arrancado = true;

      this.preguntas = [].slice.call(this.querySelectorAll('[data-faq-q]'));
      this.paneles = [].slice.call(this.querySelectorAll('[data-faq-a]'));
      if (!this.preguntas.length) return;

      /* Marca que el script corrio: el CSS lo usa para dejar de separar
         las respuestas entre si, que es como se ven sin JavaScript. */
      this.setAttribute('data-ready', '');

      for (var i = 0; i < this.preguntas.length; i += 1) {
        this.preguntas[i].addEventListener('click', this.alTocar.bind(this, i));
        this.preguntas[i].addEventListener('keydown', this.alTeclear.bind(this, i));
      }

      var abierta = this.preguntas.findIndex
        ? this.preguntas.findIndex(function (b) {
            return b.getAttribute('aria-expanded') === 'true';
          })
        : 0;

      this.abrir(abierta === -1 ? 0 : abierta);
    }

    alTocar(i) {
      /* Volver a tocar la pregunta abierta la cierra. En telefono, con la
         respuesta desplegada debajo, poder plegarla es lo que deja ver de
         nuevo la lista completa sin tener que scrollear. */
      var yaEstaba = this.preguntas[i].getAttribute('aria-expanded') === 'true';
      this.abrir(yaEstaba ? -1 : i);
    }

    /* Flechas, Home y End para recorrer la lista con el teclado. No es
       obligatorio en un acordeon, pero la seccion ya lo tenia y sacarlo
       seria una regresion para quien no usa mouse. */
    alTeclear(i, ev) {
      var ultima = this.preguntas.length - 1;
      var siguiente = null;

      if (ev.key === 'ArrowDown' || ev.key === 'ArrowRight') siguiente = i === ultima ? 0 : i + 1;
      else if (ev.key === 'ArrowUp' || ev.key === 'ArrowLeft') siguiente = i === 0 ? ultima : i - 1;
      else if (ev.key === 'Home') siguiente = 0;
      else if (ev.key === 'End') siguiente = ultima;
      if (siguiente === null) return;

      ev.preventDefault();
      this.preguntas[siguiente].focus();
    }

    abrir(i) {
      for (var j = 0; j < this.preguntas.length; j += 1) {
        var on = j === i;
        this.preguntas[j].setAttribute('aria-expanded', on ? 'true' : 'false');
        if (this.paneles[j]) this.paneles[j].hidden = !on;
      }
    }
  }

  customElements.define('q-faq', QFaq);
})();
